import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ChargeAreaDetailsMarkerDto, MapMarkerDetailsLazyCategory} from '../../domain/map/chargeAreaDetailsMarker';
import {HttpParamsUtil} from './utils/httpParams.util';
import {ChargePointLazyCategory} from '../../domain/infra/chargePoint/chargePoint';
import {AvailabilityMacroStatus} from '../../domain/infra/availabilityMacroStatus';
import {PlugOrientation} from '../../domain/infra/plug/plug';
import {UserAction} from '../../domain/infra/userAction';
import {ReservationDuration} from '../../domain/reservation/reservation';
import {SupportContact} from '../../domain/operator/frontEndConfig';
import {StationLazyCategory} from '../../domain/infra/station/station';

@Injectable({
    providedIn: 'root'
})
export class FrontMapMarkerHttpService {
    private http: HttpClient;

    constructor(http: HttpClient) {
        this.http = http;
    }

    public searchNearestAroundMapMarkers(params: NearestAroundMapMarkersSearchParams): Observable<Array<ChargeAreaDetailsMarkerDto>> {
        return this.http.get<Array<ChargeAreaDetailsMarkerDto>>(`/v2/front/map/markers/nearest`,
            {params: HttpParamsUtil.toHttpParams(params)});
    }

    public fetchReservationDurationOfChargeArea(chargeAreaId: string, chargePointId: string): Observable<ReservationDuration[]> {
        return this.http.get<ReservationDuration[]>(`/v2/front/map/markers/${chargeAreaId}/chargePoints/${chargePointId}/reservationDurations` );
    }

    public fetchTechnicalSupportContact(chargeAreaId: string): Observable<SupportContact> {
        return this.http.get<SupportContact>(`/v2/front/map/markers/${chargeAreaId}/technicalSupportContact`);
    }
}

export class SearchPreferencesParams {
    availableOnly?: boolean;
    plugTypeChoices?: Array<string>;
    suggestions?: Array<string>;
    powerMinInW?: number;
}

export class NearestAroundMapMarkersSearchParams extends SearchPreferencesParams {
    referenceLat: number;
    referenceLng: number;
    userLocationLat?: number;
    userLocationLng?: number;
    distanceMaxInKm: number;
    userActions?: UserAction[];
    categories?: Array<MapMarkerDetailsLazyCategory>;
    stationCategories?: Array<StationLazyCategory>;
    limit?: number;
}

export class ChargePointsParams {
    statuses?: Array<AvailabilityMacroStatus>;
    plugTypeName?: string;
    plugOrientation?: PlugOrientation;
    categories?: Array<ChargePointLazyCategory>;
    anyCurrentUserActions?: UserAction[];
}
